import React from 'react';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Col, Row, Container, Label } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../../components/DataRow';
import Segment from '../../components/Segment';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class SegmentEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            segment: {
                id: parseInt(this.props.match.params.segment_id, 10) || '',
                description: '',
                name: '',
                segment_query: '',
            },
            isCreateSegment: false,
            isLoading: false,
            isValidating: false,
            segmentUserCount: 0,
            validationError: '',
        };
    }
    componentWillMount() {
        const currentLocation = window.location.pathname;
        if (currentLocation.includes('create')) {
            // On create new segment
            this.setState({ isCreateSegment: true });
        } else {
            // On edit existing segment
            this.getSegment();
        }
    }
    componentDidMount = () => {
        
    }
    getSegment() {
        const { segment } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `segment/${segment.id}`,
            success: (response) => {
                this.setState({
                    segment: response.segment,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    saveSegment(redirect=false) {
        const { segment, isCreateSegment } = this.state;
        if (isCreateSegment) {
            delete segment.id;
        }
        api.fetchAPI({
            method: isCreateSegment ? 'post' : 'put',
            uri: `segments`,
            body: segment,
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({
                        segment: response.segment,
                        isLoading: false,
                    }, () => {
                        const segmentId = segment.id ? segment.id : response.segment.id;
                        if (redirect) {
                            window.location = `/segment/${segmentId}`;
                        }
                    });
                } else {
                    alert(response.message);
                }
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    async validateQuery() {
        await this.saveSegment();
        this.setState({ isValidating: true, segmentUserCount: null });
        const { segment } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `segment/${segment.id}/validate/query`,
            success: (response) => {
                if (response.status == 'ok') {
                    if (response.segment) {
                        this.setState({
                            segmentUserCount: response.segment.user_count,
                            validationError: '',
                        });
                    }
                } else {
                    this.setState({
                        validationError: response.message,
                    });
                }
                this.setState({ isValidating: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isValidating: false });
            }
        });
    }
    updateAttr(attribute, value) {
        const { segment } = this.state;
        segment[attribute] = value;
        this.setState({ segment });
    }
    render() {
        const {
            segment, isValidating, segmentUserCount,
            validationError,
            isCreateSegment,
        } = this.state;
        return (
            <div className="page-container">
                {isCreateSegment ?
                    <h1>Create new segment</h1>
                    :
                    <h1>{`Edit segment ${segment.id}: #${segment.name}`}</h1>
                }
                <FormGroup>
                    <Label>Name</Label>
                    <Input
                        type="text"
                        value={segment.name}
                        placeholder="Apex bigquery datasource"
                        onChange={(e) => this.updateAttr('name', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Description</Label>
                    <TextareaAutosize
                        className="form-control"
                        type="textarea"
                        value={segment.description}
                        placeholder="Love you to the moon and back"
                        onChange={(e) => this.updateAttr('description', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Segment type</Label>
                    <Input
                        className="form-control"
                        type="select"
                        value={segment.segment_type}
                        onChange={(e) => this.updateAttr('segment_type', e.target.value)}
                    >
                        <option value="normal">Normal</option>
                        <option value="event_based">Event-based</option>
                    </Input>
                </FormGroup>
                {(segment.segment_type && segment.segment_type === 'event_based') &&
                    <FormGroup>
                        <Label>Event name</Label>
                        <Input
                            type="text"
                            value={segment.event_name}
                            placeholder="Fill in accepted value"
                            onChange={(e) => this.updateAttr('event_name', e.target.value)}
                        />
                    </FormGroup>
                }
                {(segment.segment_type && segment.segment_type === 'event_based') &&
                    <FormGroup>
                        <Label>Event matched query</Label>
                        <div className="event_match_query_explanation">
                            <p>This should be a valid json follow the following rules:</p>
                            <ul>
                                <li>key: value means exact match for the key in event data</li>
                                <li>key: [array, of, value] means the key's value should be one of the item in the list</li>
                                <li>key: %value% means the string will contains the value as a substring</li>
                                <li>key: !value means the matched event will be the one that has <em>different</em> value of the key</li>
                                <li>key: {'<|>|>=|<='}value means the numeric comparison will be performed</li>
                                <li>Note that all value will be convert to lower string before comparison, except for math operators</li>
                            </ul>
                        </div>
                        <Input
                            type="text"
                            value={segment.event_match_query}
                            onChange={(e) => this.updateAttr('event_match_query', e.target.value)}
                        />
                    </FormGroup>
                }
                {(segment.segment_type && segment.segment_type === 'event_based') &&
                    <FormGroup>
                        <Label>Event processing type</Label>
                        <Input
                            className="form-control"
                            type="select"
                            value={segment.event_processing_type}
                            onChange={(e) => this.updateAttr('event_processing_type', e.target.value)}
                        >
                            <option value="once">Once</option>
                            <option value="everytime">Everytime</option>
                        </Input>
                    </FormGroup>
                }
                {(!segment.segment_type || segment.segment_type === 'normal') &&
                    <FormGroup>
                        <Label>Query</Label>
                        <TextareaAutosize
                            className="form-control"
                            type="textarea"
                            value={segment.segment_query}
                            placeholder="SELECT user_id FROM xxx WHERE abc;"
                            onChange={(e) => this.updateAttr('segment_query', e.target.value)}
                        />
                        <div>
                            {segmentUserCount > 0 &&
                                <p>SQL is valid, this segment has {segmentUserCount} user(s).</p>
                            }
                        </div>
                        <div>
                            {validationError &&
                                <p className="query-validation-error">Error: {validationError}</p>
                            }
                        </div>
                    </FormGroup>
                }
                <FormGroup>
                    <Button color="success" onClick={() => this.saveSegment(true)}>Save and Close</Button>
                </FormGroup>
                {!isCreateSegment &&
                    <FormGroup>
                        <Button
                            color={isValidating ? 'secondary': 'info'}
                            onClick={() => this.validateQuery()}
                            disabled={isValidating}
                        >
                            {isValidating ? 'Validating...' : 'Save & Validate query'}
                        </Button>
                    </FormGroup>
                }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/pages/SegmentEdit/index.js